import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService, EventManager, AlertService } from 'ng-jhipster';
import { Card } from './card.model';
import { CardService } from './card.service';
import { PaymentItem, PaymentItemService} from '../payment-item/';
import { Reservation, ReservationService, ReservationUtilService } from '../../entities/reservation';
import { Subscription } from 'rxjs/Subscription';
import { CRUD_ACTIONS, CARD_UNLIMITED_BOOKINGS_NUMBER } from '../../shared';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { NgbTabChangeEvent, NgbTabset } from '@ng-bootstrap/ng-bootstrap';
import { Principal } from '../../shared';

@Component({
    selector: 'jhi-card-detail',
    templateUrl: './card-detail.component.html'
})
export class CardDetailComponent implements OnInit, OnDestroy {

    card: Card;
    private subscription: any;
    private cardSubscription: Subscription;
    private paymentItemSubscription: any;
    private reservationSubscription: Subscription;
    paymentItems: PaymentItem[];
    paymentItemsTotalAmount = 0;
    readonly MAX_PAYMENT_ITEMS = 50;
    readonly UNLIMITED_BOOKINGS = CARD_UNLIMITED_BOOKINGS_NUMBER;
    reservations: Reservation[];
    totalReservationsAttended: number;
    totalReservationsNoShow: number;
    totalReservationsNew: number;
    isLoadingReservations: boolean = false;
    availableBookings: number;
    showBuyCardBanner: boolean;
    currentUserIsStudent: boolean;

    // variables for the tabs
    @ViewChild('tabs')
    tabSet: NgbTabset;
    currentTab: string;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private cardService: CardService,
        private eventManager: EventManager,
        private paymentItemService: PaymentItemService,
        private reservationService: ReservationService,
        private reservationUtilService: ReservationUtilService,
        private route: ActivatedRoute,
        private principal: Principal
    ) {
        this.jhiLanguageService.setLocations(['card', 'cardType', 'payment', 'paymentType', 'paymentItem',
                                              'reservation', 'reservationStatus']);
    }

    ngOnInit() {
        this.principal
                .hasOnlyAuthority('ROLE_USER')
                .then((response) => this.currentUserIsStudent = response);

        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });

        this.cardSubscription = this.eventManager
                .subscribe('cardListModification',
                (response) => {
                    this.card  = response['content']['content'];
                });

        this.paymentItemSubscription = this.eventManager
            .subscribe('paymentItemListModification', (response) => {
                this.refreshPaymentsList(response.content);
            });

         this.reservationSubscription = this.eventManager
                    .subscribe('reservationListModification',
                    (response) => this.refreshReservationList(response.content));
    }

    public onSelectChange(event: NgbTabChangeEvent) {
            this.currentTab = event.nextId;
            this.loadTab(event.nextId);
        }

    loadTab(tabId: string) {
        switch (tabId) {
            case 'card-info-tab':
                this.load(this.card.id);
            break;
            case 'payments-info-tab':
                this.loadPaymentItems(this.card.id);
            break;
            case 'bookings-info-tab':
                this.loadReservations(this.card.student.id, this.card.validSince, this.card.validUntil);
                this.loadAvailableBookings(this.card);
            break;
        }
    }

    private refreshPaymentsList(result: { action: string, content: any }) {
        switch (result.action) {
            case CRUD_ACTIONS.CREATE:
                this.paymentItems.push(result.content);
                this.calculateTotalAmount();
                break;
            case CRUD_ACTIONS.UPDATE:
                for (let index = 0; index <= this.paymentItems.length - 1; index++) {
                    let currentItem = this.paymentItems[index];
                    if (currentItem.id === result.content.id) {
                        if (currentItem.card === result.content.card) {
                            currentItem = result.content;
                        } else {
                            // the paiment item has change of product, we have to remove it from the list
                            this.paymentItems.splice(index, 1);
                        }
                        this.calculateTotalAmount();
                        break;
                    }
                }
                break;
            case CRUD_ACTIONS.DELETE:
                for (let index = 0; index <= this.paymentItems.length - 1; index++) {
                    if (this.paymentItems[index].id === result.content.id) {
                        this.paymentItems.splice(index, 1);
                        this.calculateTotalAmount();
                        break;
                    }
                }
                break;
        }
    }

    private refreshReservationList(result: { action: string, content: any }) {
        switch (result.action) {
            case CRUD_ACTIONS.CREATE:
                // not implemented
                break;
            case CRUD_ACTIONS.UPDATE:
                for (let index = 0; index <= this.reservations.length - 1; index++) {
                    let currentItem = this.reservations[index];
                    if (currentItem.id === result.content.id) {
                        if (!currentItem.card || currentItem.card !== this.card.id ) {
                            // the reservation has been unlinked from this card
                            this.reservations.splice(index, 1);
                            this.card.usedReservations--;
                        }
                        break;
                    }
                }
                break;
            case CRUD_ACTIONS.DELETE:
                for (let index = 0; index <= this.reservations.length - 1; index++) {
                    let currentItem = this.reservations[index];
                    if (currentItem.id === result.content.id) {
                        // the reservation has been deleted
                        this.reservations.splice(index, 1);
                        this.card.usedReservations--;
                        break;
                    }
                }
                break;
        }

        this.calculateReservationsStats();
    }

    load(id: number) {
        this.cardService.find(id).subscribe(card => {
            this.card = card;
            this.loadAvailableBookings(this.card);
            if (this.availableBookings <= 0 || this.isCardExpired()) {
                this.showBuyCardBanner = true;
            }
        });
    }

    loadAvailableBookings(card: Card) {
        this.availableBookings = this.cardService.getAvailableAssistances(card);
    }

    isCardExpired(): boolean {
        const today = new Date();
        today.setHours(0, 0, 0, 0);  // Set today's time to midnight

        const validUntilDate = new Date(this.card.validUntil);
        validUntilDate.setHours(0, 0, 0, 0);  // Set validUntil time to midnight

        return validUntilDate < today;
      }

    private loadPaymentItems(id: number) {
        this.paymentItemService.search({
            query: 'card.id:' + id,
            size: this.MAX_PAYMENT_ITEMS,
            sort: ['payment.id', 'desc']
        }).subscribe(
            (res: HttpResponse<PaymentItem[]>) => this.onPaymentItemSuccess(res.body, res.headers),
            (res: HttpErrorResponse) => this.onError(res)
        );
    }

    private onPaymentItemSuccess(data, headers) {
        this.paymentItems = data;
        this.calculateTotalAmount();
    }

    private loadReservations(studentId: number, from: Date, to: Date) {
        if (!this.card ) {
            return;
        }

        this.isLoadingReservations = true;
        let query = 'card.id:' + this.card.id;
        this.reservationService
            .search({
                query: query,
                sort: 'lesson.begining,desc',
                size: CARD_UNLIMITED_BOOKINGS_NUMBER
            }).subscribe(
                (res: HttpResponse<Reservation[]>) => this.onReservationSuccess(res.body, res.headers),
                (res: HttpErrorResponse) => this.onError(res)
            );
    }

    hasNotCompatibleCard(reservation: Reservation): boolean {
       return this.reservationUtilService.hasNotCompatibleCard(reservation);
    }

    hasPaymentsAndCard(reservation: Reservation): boolean {
        return reservation.card && reservation.totalPaid !== 0 ;
    }

    belongsToFreeClass(reservation: Reservation): boolean {
        return reservation.lesson && reservation.lesson.free ;
    }

    private onReservationSuccess(data: Reservation[], headers: any) {
        this.reservations = data;
        this.calculateReservationsStats();

        this.isLoadingReservations = false;
    }

    private calculateReservationsStats() {
        if (!this.reservations) {
            return;
        }

        let attendedStatus: any = 'ATTENDED';
        let noShowStatus: any = 'NO_SHOW';
        let newStatus: any = 'NEW';

        this.totalReservationsAttended = this.reservations.filter(r => {
            return r.status === attendedStatus;
        }).length;
        this.totalReservationsNoShow = this.reservations.filter(r => {
            return r.status === noShowStatus;
        }).length;
         this.totalReservationsNew = this.reservations.filter(r => {
            return r.status === newStatus;
        }).length;
    }

    getReservationStyle(reservation: Reservation): String {
        if (reservation) {
            return this.reservationUtilService.getReservationStyle(
                reservation.status.toString());
        }
        return 'text-info';
    }

    previousState() {
        window.history.back();
    }

    private calculateTotalAmount() {
        this.paymentItemsTotalAmount = 0;
        this.paymentItems.forEach((paymentItem) => {
            this.paymentItemsTotalAmount += paymentItem.amount;
        });
    }

    private onError(error: HttpErrorResponse) {
        this.alertService.error(error.error, null, null);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.cardSubscription.unsubscribe();
        this.paymentItemSubscription.unsubscribe();
        this.reservationSubscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/card/card-detail.component.ts